import { render, staticRenderFns } from "./Administer.vue?vue&type=template&id=dfc4c0f8&scoped=true&"
import script from "./Administer.vue?vue&type=script&lang=js&"
export * from "./Administer.vue?vue&type=script&lang=js&"
import style0 from "./Administer.vue?vue&type=style&index=0&id=dfc4c0f8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfc4c0f8",
  null
  
)

export default component.exports